import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OperativeDetailsComponent} from './operatives/components/operative-details/operative-details.component';
import {CompanyDashboardComponent} from './company/components/company-dashboard/company-dashboard.component';
import {CompanyDocumentsPageComponent} from './company/components/company-documents-page/company-documents-page.component';
import {DocumentViewerComponent} from './documents/components/document-viewer/document-viewer.component';
import {OperativeDocumentsPageComponent} from './operatives/components/operative-documents-page/operative-documents-page.component';
import {CompanyObservationsComponent} from './observations/components/company-observations/company-observations.component';
import {OperativesObservationsComponent} from './observations/components/operatives-observations/operatives-observations.component';
import {CompanyDocumentDetailsPageComponent} from './company/components/company-document-details-page/company-document-details-page.component';
import {OperativeDocumentDetailsPageComponent} from './operatives/components/operative-document-details-page/operative-document-details-page.component';
import {TrainingRecordDocumentsPageComponent} from './training-records/components/training-record-documents-page/training-record-documents-page.component';
import {TrainingRecordDetailsComponent} from './training-records/components/training-record-details/training-record-details.component';
import {TrainingRecordDocumentDetailsPageComponent} from './training-records/components/training-record-document-details-page/training-record-document-details-page.component';
import {CompanyOperativesComponent} from './company/components/company-operatives/company-operatives.component';
import {AuthorizeGuard} from '../api-authorization/authorize.guard';
import {MainShellComponent} from './main-shell/main-shell.component';
import {CompanyOperativeTrainingRecordsPageComponent} from './company/components/company-operative-training-records-page/company-operative-training-records-page.component';
import {CompanyAlertsPageComponent} from './alerts/components/company-alerts-page/company-alerts-page.component';
import {SupervisionAlertsPageComponent} from './alerts/components/supervision-alerts-page/supervision-alerts-page.component';
import {HelpPageComponent} from './help/pages/help-page/help-page.component';
import {HelpConsts} from './help/models/help-consts';
import {CompanyOptInGuard} from './opt-in-guard/company-opt-in.guard';
import {OrderFormPageComponent} from './company/components/order-form-page/order-form-page.component';
import {CompanyTrainingCoursesComponent} from "./admin-lists/components/company-training-courses/company-training-courses.component";
import {OperativeUploadComponent} from "./operatives/components/operative-upload/operative-upload.component";
import { AuditHistoryComponent } from './admin-lists/components/audit-history/audit-history.component';
import { TrainingCourseDetailsComponent } from "./admin-lists/components/company-training-course-details/company-training-course-details.component";
import { TrainingTypeDocumentDetailsPageComponent } from './training-records/components/training-type-document-details-page/training-type-document-details-page.component';
import { ObservationDocumentDetailsPageComponent } from './observations/components/observation-document-details-page/observation-document-details-page.component';
import { ObservationDetailsComponent } from './observations/components/observation-details/observation-details.component';
import { CompanySettingsPageComponent } from './company/components/company-settings-page/company-settings-page.component';

const routes: Routes = [
  {
    path: '',
    component: MainShellComponent,
    canActivate: [AuthorizeGuard, CompanyOptInGuard],
    data: {breadcrumb: {label: 'Dashboard', info: {iconName: 'tachometer-alt-fast'}}},
    children: [{
      path: '', component: CompanyDashboardComponent,
      data: {help: HelpConsts.CompanyDashboardHelp},
    },
      {
        path: 'dashboard', component: CompanyDashboardComponent,
        data: {help: HelpConsts.CompanyDashboardHelp},
      },
      {
        path: 'order-form', component: OrderFormPageComponent,
        data: {
          breadcrumb: {alias: 'operativeDetails', label: ' ', info: {iconName: 'user'}}
        },
      },
      {
        path: 'operatives', component: CompanyOperativesComponent,
        data: {help: HelpConsts.CompanyOperativesHelp},
      },
      {
        path: 'operative/:operativeId', component: OperativeDetailsComponent,
        data: {help: HelpConsts.OperativeDetails},
      },
      {
        path: 'createoperative/:operativeId', component: OperativeDetailsComponent,
        data: {
          breadcrumb: {alias: 'operativeDetails', label: ' ', info: {iconName: 'user'}}
        },
      },
      {
        path: 'operative-documents', component: OperativeDocumentsPageComponent,
        data: {help: HelpConsts.AllOperativeDocumentsHelp},
      },
      {
        path: 'operative-document/:documentId', component: OperativeDocumentDetailsPageComponent,
      },
      {
        path: 'operative-upload', component: OperativeUploadComponent,
      },
      {
        path: 'company-documents/:navAction', component: CompanyDocumentsPageComponent,
        data: {help: HelpConsts.CompanyDocumentsHelp},
      },
      {
        path: 'company-documents', component: CompanyDocumentsPageComponent,
        data: {help: HelpConsts.CompanyDocumentsHelp},
      },
      {
        path: 'company-document/:documentId', component: CompanyDocumentDetailsPageComponent,
      },
      {
        path: 'document/:docUrl', component: DocumentViewerComponent,
      },
      {
        path: 'company-observations', component: CompanyObservationsComponent,
        data: {help: HelpConsts.CompanyObservationsHelp},
      },
      {
        path: 'operative-observations', component: OperativesObservationsComponent,
        data: {help: HelpConsts.AllOperativeObservationsHelp},
      },
      {
        path: 'observation-details/:observationId', component: ObservationDetailsComponent,
        data: { help: HelpConsts.ObservationDetailsHelp },
      },
      {
        path: 'observation-document/:documentId', component: ObservationDocumentDetailsPageComponent,
        data: { help: HelpConsts.ObservationDocumentDetailsHelp },
      },
      {
        path: 'training-record-documents', component: TrainingRecordDocumentsPageComponent,
      },
      {
        path: 'training-record-document/:documentId', component: TrainingRecordDocumentDetailsPageComponent,
      },
      {
        path: 'training-record/:trainingRecordId', component: TrainingRecordDetailsComponent,
        data: {help: HelpConsts.TrainingRecordHelp}
      },
      {
        path: 'training-records', component: CompanyOperativeTrainingRecordsPageComponent,
        data: {help: HelpConsts.OperativeTrainingRecordsHelp},
      },
      {
        path: 'training-courses', component: CompanyTrainingCoursesComponent,
        data: {help: HelpConsts.CompanyTrainingCoursesHelp},
      },
      {
        path: 'training-course/:trainingTypeId', component: TrainingCourseDetailsComponent,
        data: { help: HelpConsts.CompanyTrainingCoursesHelp },
      },
      {
        path: 'training-course-document/:documentId', component: TrainingTypeDocumentDetailsPageComponent,
      },            
      {
        path: 'alerts', component: CompanyAlertsPageComponent,
        data: {help: HelpConsts.ActionAlertsHelp},
      },
      {
        path: 'supervision-alerts', component: SupervisionAlertsPageComponent,
        data: {help: HelpConsts.SupervisionAlertsHelp},
      },
      {
        path: 'audit-history', component: AuditHistoryComponent,
        data: { help: HelpConsts.AuditHistoryHelp },
      },
      {
        path: 'help', component: HelpPageComponent,
      },
      {
        path: 'company-settings', component: CompanySettingsPageComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
